import { clsx } from 'clsx';

import { Icons } from '@monoimin/atoms';
import { IconNamesUnion } from '@monoimin/sb-types';

type IconPointProps = {
  title?: string;
  icon?: IconNamesUnion;
  className?: string;
  iconClassName?: string;
  withoutPaddings?: boolean;
};

export function IconPoint({
  title,
  icon,
  className,
  iconClassName,
  withoutPaddings,
}: IconPointProps) {
  return (
    <div className={clsx('icon-point flex items-center', className)}>
      <div className={clsx(withoutPaddings ? 'mr-1' : 'p-4 mr-5')}>
        {icon && <Icons icon={icon} className={iconClassName} isInteractive />}
      </div>
      {title && <span className='body-small'>{title}</span>}
    </div>
  );
}
